module.exports = __webpack_public_path__ + "img/line.39d07efb.svg";